module.exports = __webpack_public_path__ + "static/media/UNI-AVAX.b98c9fc6.svg";